<template>
  <div class="w-full flex flex-wrap display-container" @click="$emit('click')">
    <div
      v-for="(item, index) in list"
      :key="index"
      :class="['flex', 'items-center', 'display-item', {'display-item--soft': soft}]"
      :style="{fontSize: itemFontSize}"
    >
      <span>
        {{ item }}
      </span>
      <van-icon
        v-if="closable"
        name="cross"
        color="rgb(202, 65, 29)"
        style="margin-left: 6px"
        @click.stop="$emit('close', index)"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Icon} from 'vant';

Vue.use(Icon);

export default {
  props: {
    list: Array,
    closable: {
      type: Boolean,
      default: true,
    },
    itemFontSize: {
      type: String,
      default: '14px',
    },
    soft: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.display-container {
  min-height: 24px;
}

.display-item {
  margin-right: 6px;
  padding: 0 8px;
  border-radius: 2px;
}

.display-item--soft {
  margin-right: 8px;
  margin-bottom: 3px;
  padding: 3px 7px;
  border: 1px solid #e5e7ea;
  border-radius: 7px;
  background: #f6f7f9;
}
</style>
